import algoliasearch from "algoliasearch/lite";
import instantsearch from "instantsearch.js";
import {
  configure,
  hits,
  searchBox,
  index,
  refinementList,
  rangeInput,
  addWidget,
  toggleRefinement,
} from "instantsearch.js/es/widgets";

const bodyLocale = document.getElementsByTagName("BODY")[0].dataset.shopLocale;
const locale = bodyLocale === "da" ? "" : bodyLocale + "_";

const searchClient = algoliasearch(
  "HZZ25JRCSO",
  "c46fe3c12f9c8031192bfc2a2416191e"
);

console.log("search", locale);

const search = instantsearch({
  indexName: locale + "shopify_moodings_products",
  searchClient,
  searchFunction(helper) {
    helper.search();
  },
});

search.addWidgets([
  configure({
    // filters: "(collections:royal-copenhagen  AND inventory_quantity>0)",
    filters: "(collections:royal-copenhagen)",
    hitsPerPage: 100,
    // analyticTags: ["mens-clothing"],
  }),

  refinementList({
    container: "#categories",
    attribute: "vendor",
  }),

  refinementList({
    container: "#product-types",
    attribute: "product_type",
    sortBy: ["name:asc", "count:desc"],
  }),

  refinementList({
    container: "#inventory",
    attribute: "inventory_available",
  }),

  rangeInput({
    container: "#price",
    attribute: "price",
  }),

  toggleRefinement({
    container: "#toggle-refinement",
    attribute: "inventory_available",
  }),

  hits({
    container: "#collection-search-hits",
    templates: {
      item: function (item) {
        return `
                <a href="/products/${item.handle}">
                <div style="display:flex;  align-items: center;">                        
                    <div class="search-results-product-image">
                        <img src="${item.product_image}" alt="${item.title}" style="width:100%;">
                    </div>
                    <div>
                        <div class="hits-products-item-title">${item.title}</div>
                        <div class="hits-products-item-description">${item.product_type} <span class="hits-products-item-divider">|</span> ${item.vendor}</div>                        
                    </div>
                </div>
                </a>
            `;
      },
    },
  }),
]);

search.start();
